var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-form",
    { on: { submit: _vm.submit } },
    [
      _c("ValidationObserver", {
        ref: "inputObserver",
        attrs: { tag: "div" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(InputObserver) {
              return [
                _c(
                  "v-row",
                  { staticClass: "mb-3" },
                  [
                    _c(
                      "v-col",
                      {
                        staticClass: "mb-2 mt-0 pt-2 pb-0",
                        attrs: { cols: "12", sm: "12", md: "3" }
                      },
                      [
                        _c(
                          "v-sheet",
                          {
                            staticClass:
                              "pt-3 pb-3  align-center fixed-label-area",
                            attrs: { color: "grey lighten-3" }
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "mb-0 font-weight-bold fixed-label text-center ml-4"
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.$t(
                                        "view.contract_form.update.label.consent.about_request"
                                      )
                                    ) +
                                    "\n                    "
                                )
                              ]
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-col",
                      {
                        staticClass: "mb-2 mt-0 pt-2 pb-0 pr-10",
                        attrs: { cols: "12", sm: "12", md: "9" }
                      },
                      [
                        _c(
                          "v-row",
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "mb-0 mt-0 pt-0 pb-0",
                                attrs: { cols: "12" }
                              },
                              _vm._l(
                                _vm.$t(
                                  "view.contract_form.update.messages.consent.about_moneyforward_request"
                                ),
                                function(block, index) {
                                  return _c(
                                    "div",
                                    {
                                      key:
                                        "about-request-message-messages-" +
                                        index,
                                      staticClass: "mb-3"
                                    },
                                    [
                                      _c(
                                        "v-row",
                                        { staticClass: "ma-0 pa-0" },
                                        [
                                          _c(
                                            "v-col",
                                            {
                                              staticClass:
                                                "ma-0 pa-0 paragraph-section",
                                              attrs: { cols: "1" }
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    ■\n                                "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "ma-0 pa-0",
                                              attrs: { cols: "11" }
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(
                                                    block["block"]["top"]
                                                  ) +
                                                  "\n                                "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm._l(
                                        block["block"]["details"],
                                        function(message, innerIndex) {
                                          return _c(
                                            "div",
                                            {
                                              key:
                                                "about-request-message-messages-" +
                                                index +
                                                "-" +
                                                innerIndex,
                                              staticClass: "pl-5"
                                            },
                                            [
                                              _vm._v(
                                                "\n                                " +
                                                  _vm._s(message) +
                                                  "\n                            "
                                              )
                                            ]
                                          )
                                        }
                                      )
                                    ],
                                    2
                                  )
                                }
                              ),
                              0
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.isEkycMainPlan() ||
                        _vm.formData.applyInfoApplyService.includes(5)
                          ? _c(
                              "v-row",
                              [
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "mb-0 mt-0 pt-0 pb-0",
                                    attrs: { cols: "12" }
                                  },
                                  _vm._l(
                                    _vm.$t(
                                      "view.contract_form.update.messages.consent.about_tablet_request_first"
                                    ),
                                    function(block, index) {
                                      return _c(
                                        "div",
                                        {
                                          key:
                                            "about-request-message-messages-" +
                                            index,
                                          staticClass: "mb-3"
                                        },
                                        [
                                          _c(
                                            "v-row",
                                            { staticClass: "ma-0 pa-0" },
                                            [
                                              index === 0
                                                ? _c(
                                                    "v-col",
                                                    {
                                                      staticClass:
                                                        "ma-0 pa-0 paragraph-section",
                                                      attrs: { cols: "1" }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                    ■\n                                "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "ma-0 pa-0",
                                                  attrs: { cols: "11" }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                    " +
                                                      _vm._s(
                                                        block["block"]["top"]
                                                      ) +
                                                      "\n                                "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _vm._l(
                                            block["block"]["details"],
                                            function(message, innerIndex) {
                                              return _c(
                                                "div",
                                                {
                                                  key:
                                                    "about-request-message-messages-" +
                                                    index +
                                                    "-" +
                                                    innerIndex,
                                                  staticClass: "pl-5"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                " +
                                                      _vm._s(message) +
                                                      "\n                            "
                                                  )
                                                ]
                                              )
                                            }
                                          )
                                        ],
                                        2
                                      )
                                    }
                                  ),
                                  0
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isEkycMainPlan() ||
                        _vm.formData.applyInfoApplyService.includes(5)
                          ? _c(
                              "v-row",
                              { staticClass: "mt-0" },
                              [
                                _c(
                                  "label",
                                  { staticClass: "fixed-label text-center" },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.$t(
                                            "view.contract_form.update.label.consent.about_tablet_price_list"
                                          )
                                        ) +
                                        "\n                            "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "mb-0 mt-0 pt-0 pb-0",
                                    attrs: { cols: "12" }
                                  },
                                  [
                                    _c("v-img", {
                                      staticClass: "mx-auto",
                                      attrs: {
                                        src:
                                          "/static/explain_tablet_detail_table.png",
                                        width: "80%"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isEkycMainPlan() ||
                        _vm.formData.applyInfoApplyService.includes(5)
                          ? _c(
                              "v-row",
                              [
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "mb-0 mt-0 pt-0 pb-0",
                                    attrs: { cols: "12" }
                                  },
                                  _vm._l(
                                    _vm.$t(
                                      "view.contract_form.update.messages.consent.about_tablet_request_second"
                                    ),
                                    function(block, index) {
                                      return _c(
                                        "div",
                                        {
                                          key:
                                            "about-request-message-messages-" +
                                            index,
                                          staticClass: "mb-3"
                                        },
                                        [
                                          _c(
                                            "v-row",
                                            { staticClass: "ma-0 pa-0" },
                                            [
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "ma-0 pa-0",
                                                  attrs: { cols: "11" }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                    " +
                                                      _vm._s(
                                                        block["block"]["top"]
                                                      ) +
                                                      "\n                                "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _vm._l(
                                            block["block"]["details"],
                                            function(message, innerIndex) {
                                              return _c(
                                                "div",
                                                {
                                                  key:
                                                    "about-request-message-messages-" +
                                                    index +
                                                    "-" +
                                                    innerIndex,
                                                  staticClass: "pl-5"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                " +
                                                      _vm._s(message) +
                                                      "\n                            "
                                                  )
                                                ]
                                              )
                                            }
                                          )
                                        ],
                                        2
                                      )
                                    }
                                  ),
                                  0
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("ValidationProvider", {
                          attrs: { vid: "aboutRequest", rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(checked) {
                                  return [
                                    _c(
                                      "v-row",
                                      { staticClass: "pl-4 mt-7 pt-0 " },
                                      [
                                        checked.errors.length > 0
                                          ? _c(
                                              "v-col",
                                              {
                                                staticClass: "pa-0 ma-0",
                                                attrs: { cols: "12" }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "theme--light v-messages error--text"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "view.contract_form.update.hint.consent.consent_check"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _c(
                                              "v-col",
                                              {
                                                staticClass: "pa-0 ma-0",
                                                attrs: { cols: "12" }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "theme--light v-messages consent-message"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "view.contract_form.update.hint.consent.consent_check"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-row",
                                      [
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "mb-0 mt-0 pt-0 pb-0",
                                            attrs: { cols: "12" }
                                          },
                                          [
                                            _c("v-checkbox", {
                                              staticClass:
                                                "mt-0 pt-0 pb-0 mb-0 consent-custom-check",
                                              attrs: {
                                                value: "true",
                                                error:
                                                  checked.errors.length > 0,
                                                label: _vm.$t(
                                                  "view.contract_form.update.label.consent.consent_check"
                                                )
                                              },
                                              model: {
                                                value: _vm.aboutRequest,
                                                callback: function($$v) {
                                                  _vm.aboutRequest = $$v
                                                },
                                                expression: "aboutRequest"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.isShowKobetuBikoLink()
                  ? _c(
                      "v-row",
                      { staticClass: "mb-3" },
                      [
                        _c(
                          "v-col",
                          {
                            staticClass: "mb-2 mt-0 pt-2 pb-0",
                            attrs: { cols: "12", sm: "12", md: "3" }
                          },
                          [
                            _c(
                              "v-sheet",
                              {
                                staticClass:
                                  "pt-3 pb-3  align-center fixed-label-area",
                                attrs: { color: "grey lighten-3" }
                              },
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass:
                                      "mb-0 font-weight-bold fixed-label ml-4"
                                  },
                                  [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(_vm.getKobetuTokubetuConsent()) +
                                        "\n                    "
                                    )
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          {
                            staticClass: "mb-2 mt-0 pt-2 pb-0 pr-10",
                            attrs: { cols: "12", sm: "12", md: "9" }
                          },
                          [
                            _c(
                              "v-row",
                              [
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "mb-0 mt-2 pt-0 pb-0",
                                    attrs: { cols: "12" }
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          target: "_blank",
                                          href: _vm.formData.kobetuPriceBookUrl
                                        }
                                      },
                                      [_vm._v("重要事項")]
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("ValidationProvider", {
                              attrs: {
                                vid: "aboutKobetuTokubetu",
                                rules: "required"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(checked) {
                                      return [
                                        _c(
                                          "v-row",
                                          { staticClass: "pl-4 mt-7 pt-0 " },
                                          [
                                            checked.errors.length > 0
                                              ? _c(
                                                  "v-col",
                                                  {
                                                    staticClass: "pa-0 ma-0",
                                                    attrs: { cols: "12" }
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "theme--light v-messages error--text"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "view.contract_form.update.hint.consent.consent_check"
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _c(
                                                  "v-col",
                                                  {
                                                    staticClass: "pa-0 ma-0",
                                                    attrs: { cols: "12" }
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "theme--light v-messages consent-message"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "view.contract_form.update.hint.consent.consent_check"
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-row",
                                          [
                                            _c(
                                              "v-col",
                                              {
                                                staticClass:
                                                  "mb-0 mt-0 pt-0 pb-0",
                                                attrs: { cols: "12" }
                                              },
                                              [
                                                _c("v-checkbox", {
                                                  staticClass:
                                                    "mt-0 pt-0 pb-0 mb-0 consent-custom-check",
                                                  attrs: {
                                                    value: "true",
                                                    error:
                                                      checked.errors.length > 0,
                                                    label: _vm.$t(
                                                      "view.contract_form.update.label.consent.consent_check"
                                                    )
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.aboutKobetuTokubetu,
                                                    callback: function($$v) {
                                                      _vm.aboutKobetuTokubetu = $$v
                                                    },
                                                    expression:
                                                      "aboutKobetuTokubetu"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isShowOralCareBikoLink()
                  ? _c(
                      "v-row",
                      { staticClass: "mb-3" },
                      [
                        _c(
                          "v-col",
                          {
                            staticClass: "mb-2 mt-0 pt-2 pb-0",
                            attrs: { cols: "12", sm: "12", md: "3" }
                          },
                          [
                            _c(
                              "v-sheet",
                              {
                                staticClass:
                                  "pt-3 pb-3  align-center fixed-label-area",
                                attrs: { color: "grey lighten-3" }
                              },
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass:
                                      "mb-0 font-weight-bold fixed-label ml-4"
                                  },
                                  [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(
                                          _vm.getOralCareTokubetuConsent()
                                        ) +
                                        "\n                    "
                                    )
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          {
                            staticClass: "mb-2 mt-0 pt-2 pb-0 pr-10",
                            attrs: { cols: "12", sm: "12", md: "9" }
                          },
                          [
                            _c(
                              "v-row",
                              [
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "mb-0 mt-2 pt-0 pb-0",
                                    attrs: { cols: "12" }
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          target: "_blank",
                                          href:
                                            _vm.formData.oralCarePriceBookUrl
                                        }
                                      },
                                      [_vm._v("重要事項")]
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("ValidationProvider", {
                              attrs: {
                                vid: "aboutOralCareTokubetu",
                                rules: "required"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(checked) {
                                      return [
                                        _c(
                                          "v-row",
                                          { staticClass: "pl-4 mt-7 pt-0 " },
                                          [
                                            checked.errors.length > 0
                                              ? _c(
                                                  "v-col",
                                                  {
                                                    staticClass: "pa-0 ma-0",
                                                    attrs: { cols: "12" }
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "theme--light v-messages error--text"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "view.contract_form.update.hint.consent.consent_check"
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _c(
                                                  "v-col",
                                                  {
                                                    staticClass: "pa-0 ma-0",
                                                    attrs: { cols: "12" }
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "theme--light v-messages consent-message"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "view.contract_form.update.hint.consent.consent_check"
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-row",
                                          [
                                            _c(
                                              "v-col",
                                              {
                                                staticClass:
                                                  "mb-0 mt-0 pt-0 pb-0",
                                                attrs: { cols: "12" }
                                              },
                                              [
                                                _c("v-checkbox", {
                                                  staticClass:
                                                    "mt-0 pt-0 pb-0 mb-0 consent-custom-check",
                                                  attrs: {
                                                    value: "true",
                                                    error:
                                                      checked.errors.length > 0,
                                                    label: _vm.$t(
                                                      "view.contract_form.update.label.consent.consent_check"
                                                    )
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.aboutOralCareTokubetu,
                                                    callback: function($$v) {
                                                      _vm.aboutOralCareTokubetu = $$v
                                                    },
                                                    expression:
                                                      "aboutOralCareTokubetu"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      {
                        staticClass: "ml-3 mb-0 mt-0 pt-3 pb-0",
                        attrs: { cols: "12", sm: "12", md: "4" }
                      },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: { depressed: "", type: "button" },
                            on: { click: _vm.back }
                          },
                          [
                            _vm.isEkycMainPlan() ||
                            _vm.formData.applyInfoApplyService.includes(5)
                              ? _c("div", [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$t(
                                          "view.contract_form.update.button_caption.back_to_shipping_address_info"
                                        )
                                      ) +
                                      "\n                "
                                  )
                                ])
                              : _c("div", [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$t(
                                          "view.contract_form.update.button_caption.back_to_request_info"
                                        )
                                      ) +
                                      "\n                "
                                  )
                                ])
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-col",
                      {
                        staticClass: "mb-0 mt-0 pt-3 pb-0",
                        attrs: { cols: "12", sm: "12", md: "4" }
                      },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              depressed: "",
                              block: true,
                              type: "submit",
                              color: "#11479B",
                              dark: true
                            }
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.$t(
                                    "view.contract_form.update.button_caption.to_confirm"
                                  )
                                ) +
                                "\n                "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2e857c48", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e857c48","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contract_form/Consent.vue
// module id = /1jY
// module chunks = 1